'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Ripple = require('./Ripple');

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Ripple2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/ripple/index.js
 ** module id = 238
 ** module chunks = 0
 **/